export default __webpack_public_path__ + "static/media/gamification-img-sm.c800277b.png";